export function createPaginationArray(
  current: number,
  total: number,
  currentPage: number,
  maxPages: number = 8
): (number | string)[] {
  const pages: (number | string)[] = [];

  if (total <= maxPages) {
    for (let i = current; i < total; i++) {
      pages.push(i + 1);
    }
    return pages;
  }

  pages.push(1);

  let start = Math.max(2, currentPage + 1 - Math.floor(maxPages / 2));
  let end = Math.min(total - 1, start + maxPages - 3);

  if (start > 2) {
    pages.push('...');
  }

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  if (end < total - 1) {
    pages.push('...');
  }

  if (total > 1) {
    pages.push(total);
  }

  return pages;
}
